export const TaskActionTypes = {
    FETCHING_TASKS_START: 'FETCHING_TASKS_START',
    FETCHING_TASKS_SUCCESS: 'FETCHING_TASKS_SUCCESS',
    FETCHING_TASKS_FAILURE: 'FETCHING_TASKS_FAILURE',
    SET_TASK_QUERY: 'SET_TASK_QUERY',
    SET_TASKS: 'SET_TASKS',
    SET_TASK_COUNTS: 'SET_TASK_COUNTS',
    SET_TASK_COUNT_AND_PROJECT_LIST: 'SET_TASK_COUNT_AND_PROJECT_LIST',
    SET_PERMISSION: 'SET_PERMISSION',
    FETCHING_DOCUMENT_START: 'FETCHING_DOCUMENT_START',
    FETCHING_DOCUMENT_FINISH: 'FETCHING_DOCUMENT_FINISH',
    FETCHING_DOCUMENT_FAILURE: 'FETCHING_DOCUMENT_FAILURE',
    SUBMIT_DOCUMENT_START: 'SUBMIT_DOCUMENT_START',
    SUBMIT_DOCUMENT_FINISH: 'SUBMIT_DOCUMENT_FINISH',
    SUBMIT_DOCUMENT_FAILURE: 'SUBMIT_DOCUMENT_FAILURE',
    SET_DOCPATH: 'SET_DOCPATH',
    SET_ORIGINAL_DOCPATH: 'SET_ORIGINAL_DOCPATH',
    SET_DOCPATH_BLACKLINE: 'SET_DOCPATH_BLACKLINE',
    SET_SELECTED_TASKS: 'SET_SELECTED_TASKS',
    SET_PPT_DOCUMENT_DETAILS: 'SET_PPT_DOCUMENT_DETAILS',

    ADD_SELECTED_TASKS: 'ADD_SELECTED_TASKS',
    DELETE_SELECTED_TASKS: 'DELETE_SELECTED_TASKS',
    ADD_MULTIPLE_SELECTED_TASKS: 'ADD_MULTIPLE_SELECTED_TASKS',
    DELETE_MULTIPLE_SELECTED_TASKS: 'DELETE_MULTIPLE_SELECTED_TASKS',
    SET_GROUP_TASKS_BY: 'SET_GROUP_TASKS_BY',
    SET_TASKS_GROUPED: 'SET_TASKS_GROUPED',
    SET_FILTERED_AND_SORTED_TASKS: 'SET_FILTERED_TASKS',

    RESET_TASKS: 'RESET_TASKS',
}